// Единственный экземпляр роутера: нужен функциям, вызываемым вне компонентов (navigateTo, clearError).
import type { Router, RouteLocationRaw } from 'vue-router';

export let router: Router;
export function setRouter(instance: Router) { router = instance; }

export async function navigateTo(to: RouteLocationRaw, options: { replace?: boolean; external?: boolean } = {}): Promise<void> {
  if (options.external && typeof to === 'string') { window.location.href = to; return; }
  await (options.replace ? router.replace(to) : router.push(to));
}
